import axios from 'axios';

// API URL'lerini düzgün yapılandır
const API_URL = import.meta.env.VITE_API_URL || 'https://new-api.cloudmedia.com.tr/api';
const MANAGER_URL = import.meta.env.VITE_MANAGER_URL || 'https://panel.cloudmedia.com.tr';

// Manager API için ayrı bir axios instance oluştur
const managerApi = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Token'ı otomatik ekle
managerApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('manager_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const managerAuthService = {
  // Manager paneline direkt giriş için token al
  async getLoginToken(managerId: string): Promise<string> {
    const superAdminToken = localStorage.getItem('token'); // Super admin token'ı

    try {
      // API endpoint'i doğru formatta olduğundan emin ol
      const loginTokenEndpoint = `${API_URL}/auth/managers/${managerId}/login-token`;

      const response = await axios.post(loginTokenEndpoint, {}, {
        headers: {
          'Authorization': `Bearer ${superAdminToken}`,
          'Content-Type': 'application/json'
        }
      });

      // Response formatını kontrol et
      const token = response.data?.token || (response.data?.data ? response.data.data.token : null);
      
      if (!token) {
        console.error('Token alınamadı:', response.data);
        throw new Error('Token alınamadı');
      }
      
      return token;
    } catch (error) {
      console.error('Login token alma hatası:', error);
      throw error;
    }
  },

  // Manager panel URL'ini oluştur
  getLoginUrl(token: string): string {
    // URL'nin doğru formatta olduğundan emin olalım
    let baseUrl = MANAGER_URL;
    // Trailing slash kontrolü
    if (baseUrl.endsWith('/')) {
      baseUrl = baseUrl.slice(0, -1);
    }

    return `${baseUrl}/auth/direct-login?token=${encodeURIComponent(token)}`;
  }
};
